import React from "react";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import { CACHE_QUERY_TYPE } from "src/constants/actionCache";
import ShowCacheFLFQueryType from "../ShowCache/ShowCacheFLFQueryType";
import FLFQueryTypePopup from "../Popup/FLFQueryTypePopup";

const FLFQueryTypeControlPanel = ({
  children,
  currentActionCache,
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache Query Type"
          isShowButton={isShowCache(currentActionCache, CACHE_QUERY_TYPE)}
        >
          <ShowCacheFLFQueryType
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>

        <FLFQueryTypePopup
          recordForEdit={recordForEdit}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          handleOpenPopup={handleOpenPopup}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
        />
      </div>
    </div>
  );
};

export default FLFQueryTypeControlPanel;
